import { Button, Form, Col } from "react-bootstrap";

const CardForm = ({setCard, setCvv, setMonth, setName, setYear, Pay}) => {
    return(
        <Form className = 'cardForm'>
            <Form.Label><h6>Card Info</h6></Form.Label>
            <Form.Row>
                <Form.Group as={Col} controlId="formGridNickname">
                    <Form.Label>Name</Form.Label>
                    <Form.Control type="text" placeholder="As printed on the card" 
                    onChange = {(e) => setName(e.target.value)}/>
                </Form.Group>
            </Form.Row>
            
            <Form.Group controlId="formGridCardNo">
                <Form.Label>Card Number</Form.Label>
                <Form.Control placeholder="XXXX XXXX XXXX"
                onChange = {(e) => setCard(e.target.value)}/>
            </Form.Group>
            <Form.Row>
                <Form.Group as={Col} controlId="formGridMonth">
                    <Form.Label>Month</Form.Label>
                    <Form.Control placeholder="08"
                    onChange = {(e) => setMonth(e.target.value)}/>
                </Form.Group>
                <Form.Group as={Col} controlId="formGridYear">
                    <Form.Label>Year</Form.Label>
                    <Form.Control placeholder="2030"
                    onChange = {(e) => setYear(e.target.value)}/>
                </Form.Group>
                <Form.Group as={Col} controlId="formGridCVV">
                    <Form.Label>CVV</Form.Label>
                    <Form.Control onChange = {(e) => setCvv(e.target.value)}/>
                </Form.Group>
            </Form.Row>
            <Button variant="dark" type="submit" onClick = {Pay}>
                Submit
            </Button>
        </Form>
    );
}

export default CardForm;